import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { referralPartnerApi } from '@/api/referralPartner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

export default function PartnerProfile() {
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ['partner-me'],
    queryFn: async () => {
      const res = await referralPartnerApi.me();
      return res.data?.data?.partner;
    },
  });

  const [form, setForm] = useState<Record<string, string>>({});

  const saveMut = useMutation({
    mutationFn: () => referralPartnerApi.updateProfile(form),
    onSuccess: () => {
      toast.success('Profile saved');
      qc.invalidateQueries({ queryKey: ['partner-me'] });
    },
    onError: () => toast.error('Save failed'),
  });

  const fields = [
    ['pan', 'PAN'],
    ['aadhaar', 'Aadhaar'],
    ['bankName', 'Bank name'],
    ['accountNumber', 'Account number'],
    ['ifscCode', 'IFSC'],
    ['panDocUrl', 'PAN document URL'],
    ['aadhaarDocUrl', 'Aadhaar document URL'],
    ['cancelledChequeUrl', 'Cancelled cheque URL'],
  ] as const;

  return (
    <div className="space-y-6 w-full max-w-lg">
      <div>
        <h2 className="text-2xl font-bold text-white">Profile & KYC</h2>
        <p className="text-slate-400">Bank details required before payout</p>
      </div>
      <div className="rounded-2xl border border-white/10 bg-white/5 p-5 text-sm text-slate-300">
        <p>{data?.firstName} {data?.lastName}</p>
        <p>{data?.email}</p>
        <p>{data?.phone}</p>
        <p className="mt-2 text-xs text-slate-500">Status: {data?.status}</p>
      </div>
      <form
        className="space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          saveMut.mutate();
        }}
      >
        {fields.map(([key, label]) => (
          <div key={key}>
            <label className="text-xs text-slate-400">{label}</label>
            <Input
              defaultValue={(data as Record<string, string>)?.[key] ?? ''}
              onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
              className="mt-1 border-white/10 bg-slate-900 text-white h-11"
            />
          </div>
        ))}
        <Button type="submit" disabled={saveMut.isPending} className="bg-cyan-600 h-11 w-full sm:w-auto">
          Save KYC details
        </Button>
      </form>
    </div>
  );
}
